import pdfMake from 'pdfmake/build/pdfmake';
import 'pdfmake/build/vfs_fonts';

import tinycolor from 'tinycolor2';
import { clone } from '../../schedule';
import Swal from 'sweetalert2';
import { calculateFontSize, pdf_concatenate } from '../../candidates';
import { openPdfInNewTabOrAlert } from '../../pdfOpen';
import rezRateLogo from '../rezRateLogo.png';

import bgGuide from './AVERY_5390.png';
import { imageToBase64 } from 'Common.functions';

let rezRateLogoBase64 = null;
// 1 inch = 72 units.
// LETTER size is 612x792

const tableLayouts = {
  customTable: {
    hLineWidth: (i, node) => {
      return 0;
      // if (i === 0 || i === node.table.body.length) {
      //   return 0;
      // }
      // return i === node.table.headerRows ? 2 : 1;
    },
    vLineWidth: (i) => {
      return 0;
    },
    hLineColor: (i) => {
      return i === 1 ? 'black' : '#aaa';
    },
    paddingLeft: (i) => {
      return 0;
    },
    paddingRight: (i, node) => {
      return 0;
    },
    paddingTop: (i, node) => {
      return 0;
    },
    paddingBottom: (i, node) => {
      return 0;
    },
  },
};

const truncate = (wordToTruncate, limit = 0, forcedCut) => {
  if (wordToTruncate == null) {
    return '';
  }
  if (limit == 0 || wordToTruncate.length < limit + 1) {
    return wordToTruncate;
  } else if (forcedCut) {
    return `${wordToTruncate.slice(0, limit)}`;
  } else if (wordToTruncate.length > limit + 1) {
    return `${wordToTruncate.slice(0, limit - 5)}. . .`;
  }
};

const createPDFProper = async (data) => {
  const { interviewDate, candidates = [], department, departmentLogo, onProgress } = data;
  const { ProgramType } = department;

  const rows = [];
  let counter = 0;
  const renderCard = (candidate, counter) => {
    const cardRows = [];
    const subTextKey = 'CandidateSubHeading';
    const deptLogo = {
      width: 50,
      columns: [
        {
          image: `data:image/png;base64,${departmentLogo || rezRateLogoBase64}`,
          // width: 80,
          fit: [50, 40],
        },
      ],
      margin: [10, 0, 10, 0],
    };

    cardRows.push({
      columns: [
        deptLogo,
        {
          width: 190,
          // text: pdf_concatenate({ string: department.DepartmentName, maxLimit: 30 }),
          text: department.DepartmentName,
          style: {
            alignment: 'left',
            fontSize: calculateFontSize({
              text: department.DepartmentName,
              maxWidth: 450,
              maxHeight: 18,
            }),
          },
          fillColor: '#f5f5f5',
          margin: [10, 5, 0, 0],
        },
      ],
      margin: [0, 20, 0, 5],
    });

    cardRows.push({ canvas: [{ type: 'line', x1: 10, y1: 0, x2: 242, y2: 0, lineWidth: 1 }] });
    cardRows.push([
      {
        style: { alignment: 'center', bold: true },
        text: `${candidate.FirstName || ''} ${candidate.LastName || ''}`,
        fontSize: calculateFontSize({
          text: `${candidate.FirstName || ''} ${candidate.LastName || ''}`,
          maxWidth: 200,
          maxHeight: 20,
          startingFontSize: 20,
        }),
        width: 200,
        margin: [10, 15, 10, 0],
      },
    ]);

    cardRows.push([
      {
        style: { alignment: 'center' },
        text: `${candidate[subTextKey] ? `${candidate[subTextKey]}` : '---'}`,
        fontSize: calculateFontSize({
          text: candidate[subTextKey] ? `${candidate[subTextKey]}` : '---',
          maxWidth: 450,
          maxHeight: 18,
        }),
        width: 200,
        margin: [10, 10, 10, 10],
      },
    ]);

    return cardRows;
  };

  // Process candidates in chunks to keep UI responsive
  const CHUNK_SIZE = 50;
  const totalCandidates = candidates.length;

  while (counter < totalCandidates) {
    const chunkEnd = Math.min(counter + CHUNK_SIZE, totalCandidates);

    // Process one chunk
    for (let i = counter; i < chunkEnd; i++) {
      const tableRow = [];

      tableRow.push(renderCard(candidates[i], i));
      i++;
      if (i < totalCandidates) {
        tableRow.push(renderCard(candidates[i], i));
      } else {
        tableRow.push({ text: '' });
      }

      rows.push(tableRow);
    }

    counter = chunkEnd;

    // Report progress
    if (onProgress) {
      onProgress({ current: counter, total: totalCandidates });
    }

    // Yield to browser between chunks to keep UI responsive
    if (counter < totalCandidates) {
      await new Promise((resolve) => setTimeout(resolve, 0));
    }
  }

  let pdfObject = [
    {
      table: { heights: 2.23 * 72, widths: [3.5 * 72, 3.5 * 72], body: rows, dontBreakRows: true },
      layout: 'customTable',
    },
  ];

  if (rows.length <= 0) {
    Swal.fire('Error', 'There are no Candidates for this Interview Date. There is nothing to print!', 'error');
    return;
  }
  // imageToBase64(bgGuide)
  //   .then((bgBase64) => {
  // console.log('bgBase64: ', `data:image/png;base64,${bgBase64}`);
  const docDefinition = {
    // background: { image: `data:image/png;base64,${bgBase64}`, width: 612 },
    info: { title: 'Candidate Badges 5390' },
    pageSize: 'LETTER',
    pageOrientation: 'portrait',
    content: pdfObject,
    defaultStyle: {
      fontSize: 15,
    },
    pageMargins: [0.75 * 72, 72, 0.75 * 72, 72],
  };

  const pdfDocGenerator = pdfMake.createPdf(docDefinition, tableLayouts);
  openPdfInNewTabOrAlert({
    pdfDocGenerator,
    downloadTitle: 'Candidate_Badges_5390',
    allowDownloadFallback: false,
    previewCallback: data.previewCallback,
  });
  if (!data.previewCallback) {
    pdfDocGenerator.download('Candidate_Badges_5390.pdf');
  }
  // })
  // .catch((err) => {});
};

export const createPDFForCandidateBadges = ({
  interviewDate,
  department,
  candidates = [],
  callback,
  onProgress,
  previewCallback,
}) => {
  const startProper = async () => {
    const candidatesCopy = clone(candidates);
    if (department.DepartmentLogo) {
      imageToBase64({
        url: department.DepartmentLogo,
        callback: async (err, res) => {
          try {
            await createPDFProper({
              candidates: candidatesCopy,
              department,
              departmentLogo: res,
              onProgress,
              previewCallback,
            });
            if (!previewCallback && callback) {
              callback();
            }
          } catch (error) {
            console.error('Error creating PDF:', error);
            if (previewCallback) {
              previewCallback(null, null, error);
            } else if (callback) {
              callback(error);
            }
          }
        },
      });
    } else {
      try {
        await createPDFProper({ candidates: candidatesCopy, department, onProgress, previewCallback });
        if (!previewCallback && callback) {
          callback();
        }
      } catch (error) {
        console.error('Error creating PDF:', error);
        if (previewCallback) {
          previewCallback(null, null, error);
        } else if (callback) {
          callback(error);
        }
      }
    }
  };

  // if (department.DepartmentLogo) {
  //   imageToBase64(department.DepartmentLogo)
  //     .then((res) => {
  //       if (callback) {
  //         callback();
  //       }
  //       createPDFProper({ candidates: candidatesCopy, department, departmentLogo: res });
  //     })
  //     .catch((err) => {});
  // } else {
  //   createPDFProper({ interviewDate, candidates: candidatesCopy, department });
  // }

  imageToBase64({
    url: rezRateLogo,
    callback: (err, res) => {
      rezRateLogoBase64 = res;
      startProper();
    },
  });
};
